var $8460c13bb2d75345$exports = {};
$8460c13bb2d75345$exports = {
    "alpha": `Alpha`,
    "blue": `Sininen`,
    "brightness": `Kirkkaus`,
    "green": `Vihre\xe4`,
    "hue": `S\xe4vy`,
    "lightness": `Valom\xe4\xe4r\xe4`,
    "red": `Punainen`,
    "saturation": `V\xe4rikyll\xe4isyys`
};


export {$8460c13bb2d75345$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
